module.exports = __webpack_public_path__ + "4ae6fa049141dc143e805f6681030dab.png";